import { useQuery } from "@tanstack/react-query";
import api from "../../http";

export interface MostPopularManufacturer {
    _id: string;
    name: string;
    totalProducts: number;
}

export const useGetMostPopularManufacturers = () => {
    return useQuery<MostPopularManufacturer[]>({
        queryKey: ['manufacturers', 'mostPopular'],
        queryFn: async () => (await api.get('/manufacturer/mostPopular')).data,
    });
};
